/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * How actualize found the target cut of an auto-replaced row. id: the same cut id. normalizedName: a cut of the new edition whose name differs only in case, punctuation or spacing, as DataHub normalizes cut names.
 */
export enum SurveyReplacementDataCutMatchType {
    ID = 'id',
    NORMALIZED_NAME = 'normalizedName',
}
